import React from "react";
import { StyledButton } from "components/atoms/RedButton/RedButton.styles";

export default function RedButton(props) {
  return <StyledButton {...props}></StyledButton>;
}
